const playerTransitionDurationMs = 150;
const playerContainerCls = "_rsp1rcy2h9";
const playerCls = "_rsp1a169wc";

export { playerCls, playerContainerCls, playerTransitionDurationMs };
import "./_sticky-audio-player.style.linaria.module.css";
//# sourceMappingURL=_sticky-audio-player.style.js.map
